import { useTheme } from '@cellectenergy/cellect-react-components'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

// Domain
import { Pagination as PostPagination, PostListItem } from '@/domains/post'

// Components
import Box from '@mui/material/Box'
import Pagination from '@mui/material/Pagination'
import Typography from '@mui/material/Typography'
import PostCard from './PostCard'
import { SectionLayout } from '@/layouts'

// Styles
import * as Styled from './List.styles'

const List = ({
  posts,
  pagination,
}: // paginationInfo,
{
  posts: PostListItem[]
  pagination: PostPagination | null
}) => {
  const router = useRouter()
  const theme = useTheme()

  // Prefetch top blog posts to speed up first navigation
  useEffect(() => {
    posts.slice(0, 3).forEach((p) => {
      if (p.slug) {
        // Preload the JSON and code for the post page
        ;(async () => {
          try {
            await (router as any)?.prefetch?.(`/blog/${p.slug}`)
          } catch {}
        })()
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [posts.map((p) => p.slug).join(',')])

  return (
    <SectionLayout>
      <Styled.ResultsContainer>
        {posts && posts.length === 0 ? (
          <Box
            sx={{
              display: 'flex',
              height: '15rem',
              width: '100%',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Typography color={theme.palette.common.corporateColors.primary.white}>
              There are no posts to display
            </Typography>
          </Box>
        ) : null}

        {posts && posts.length > 0 ? (
          <Styled.PostCardLayout>
            {posts.map((post: PostListItem) => (
              <PostCard className={`list`} key={post.id} post={post} />
            ))}
          </Styled.PostCardLayout>
        ) : null}

        {pagination && pagination.pageCount > 0 ? (
          <Styled.PaginationContainer padding={{ xs: '2rem 0 0', md: '2.875rem 0 0', lg: '3.5rem 0 0' }}>
            <Pagination
              variant="outlined"
              sx={{
                '& .MuiPaginationItem-root': {
                  padding: '1rem',
                  borderRadius: '50%',
                  fontSize: '1rem',
                  borderColor: 'transparent',
                  color: theme.palette.common.corporateColors.primary.white,
                  width: '40px',
                  height: '40px',
                  backgroundColor: 'transparent',
                },
                '& .MuiPaginationItem-page.Mui-selected': {
                  borderColor: theme.palette.common.corporateColors.secondary.turquoise,
                  color: theme.palette.common.corporateColors.primary.white,
                  backgroundColor: 'transparent',
                },
                '& .MuiPaginationItem-ellipsis': {
                  color: theme.palette.common.corporateColors.primary.warmGray,
                },
                '& .MuiPaginationItem-previous, .MuiPaginationItem-next': {
                  color: theme.palette.common.corporateColors.primary.white,
                },
              }}
              onChange={(event, page) => {
                const q = { ...router.query, page }
                router.push({ query: q }, undefined, {
                  shallow: true,
                })
              }}
              page={pagination.page}
              count={pagination.pageCount}
            />
          </Styled.PaginationContainer>
        ) : null}
      </Styled.ResultsContainer>
    </SectionLayout>
  )
}

export default List
